var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timer-redirect"},[_c('p',{staticClass:"body2"},[_vm._v(" You will be redirected to the "+_vm._s(_vm.pageNameForUser)+" page in ")]),_c('p',{staticClass:"h4-title font-semibold"},[_vm._v(" "+_vm._s(_vm.timerForUser)+" ")]),_c('p',{staticClass:"body2"},[_vm._v(" seconds ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }